module.exports = {"showText":"montrer","hideText":"cacher","shownText":"Mot de passe est caché","hiddenText":"Mot de passe est visible","passwordPlaceholder":"Entrer le mot de passe","passwordLabel":"Mot de passe","textLabel":"Prénom","textPlaceholder":"Prénom","textInputInfoMessage":"Ceci est un message d'information","textInputErrorMessage":"Ceci est un message d'erreur","textInputMessage":"Ceci est un message d'information","copyrightText":"French Pearson Education Inc. All Rights Reserved"}


//////////////////
// WEBPACK FOOTER
// ./demo/translations/fr.json
// module id = ./demo/translations/fr.json
// module chunks = 0